module.exports = __webpack_public_path__ + "img/arrowDown.23d47859.svg";